import getSelectedColorVariantIdVariantSelect from 'modules/variant/redux/selectors/get-selected-color-variant-id'
import React from 'react'
import FlexColumn from 'components/FlexColumn'
import ProductSubscribeAndSaveDeliveryLabel from 'pages/Product/containers/SubscribeAndSave/components/DeliveryLabel'
import './index.css'
import QuickShopProductSidebarDeliverySubscribeAndSaveButton from 'containers/QuickShopProductSidebar/components/Delivery/SubscribeAndSaveButton'
import QuickShopProductSidebarDeliveryOneTimePurchaseButton from 'containers/QuickShopProductSidebar/components/Delivery/OneTimePurchaseButton'
import useSelector from 'hooks/use-selector'

/**
 * @param props
 * @param props.discountPrice
 * @param props.discountPrice
 * @return {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarDelivery (props) {
  const variantId = useSelector(getSelectedColorVariantIdVariantSelect)
  return (
    <FlexColumn
      className='quick-shop-product-sidebar-delivery'
    >
      <ProductSubscribeAndSaveDeliveryLabel
        isFromQuickShop
        isShort
      />

      <div className='quick-shop-product-sidebar-delivery-buttons'>
        <QuickShopProductSidebarDeliverySubscribeAndSaveButton
          variantId={variantId}
          {...props}
        />
        <QuickShopProductSidebarDeliveryOneTimePurchaseButton
          variantId={variantId}
          {...props}
        />
      </div>
    </FlexColumn>
  )
}
